import React from "react";

export const SuppliersStrip = ({ suppliers }) => {
  if (!suppliers || suppliers.length === 0) return null;
  return (
    <section
      id="suppliers"
      data-testid="suppliers-strip"
      className="mx-auto max-w-7xl px-4 py-10 sm:px-8"
    >
      <div className="mb-6 text-center">
        <span className="font-mono text-xs uppercase tracking-widest text-cyan-400">
          Partenaires comparés
        </span>
        <h2 className="mt-2 font-heading text-2xl font-bold text-slate-50 sm:text-3xl">
          Les meilleurs équipementiers du marché
        </h2>
      </div>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
        {suppliers.map((s) => (
          <div
            key={s.id}
            data-testid={`supplier-strip-${s.id}`}
            className="surface-card surface-card-hover flex items-center gap-3 rounded-xl p-4"
          >
            <div
              className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg font-heading text-base font-black text-white"
              style={{ background: s.couleur }}
            >
              {s.logo_initial}
            </div>
            <div className="min-w-0">
              <div className="truncate font-heading text-sm font-bold text-slate-100">
                {s.nom}
              </div>
              <div className="truncate font-mono text-[10px] uppercase tracking-widest text-slate-500">
                {s.badge}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
